import { createContext } from 'react'

import { DittoIssuesManagementClient } from './types'

export type DittoStoreContextProps = {
  client?: DittoIssuesManagementClient
}
/** Ditto store context. */
const DittoIssuesContext = createContext<DittoStoreContextProps>({})

export default DittoIssuesContext
